import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    face.m.two,
    [
      face.u.one,
      face.m.two,
      face.u.two,
      face.m.two,
    ],
    face.u.one,
    face.m.two,
  ],
  name: 'H Prem',
};
